<template>
  <div class="tos-wrapper">
    <div class="tos-container">
      <router-view></router-view>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tos-wrapper {
  margin: 0 auto;
  font-size: 16px;
  line-height: 24px;
  overflow: hidden;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background-color: #f1f1f1;
  align-items: center;

  .tos-container {
    max-width: 1200px;
    margin: 24px;
  }

  :deep(h1),
  :deep(h2),
  :deep(h3),
  :deep(h4),
  :deep(h5),
  :deep(h6) {
    margin: 18px 0 !important;
  }
}
</style>
